
import { MutationTypes, useStore } from "@/store";
import { defineComponent, reactive, ref, UnwrapRef } from "vue";
import { PAY010, PAY010FormValidateRule } from "@/forms/pay010";
import useVuelidate from "@vuelidate/core";
import ErrorField from "common/src/components/ErrorField.vue";
import router from "@/router";
import { scrollToError } from "common/src/utils/screen";
import { postRenewalChange } from "@/api/renewalSubmit";
import axios from "axios";
import { setErrorMessage } from "common/src/utils/validate";
import { ErrorResponse } from "common/src/utils/request";
import constants from "common/src/constants";

export default defineComponent({
  components: {
    ErrorField,
  },
  setup() {
    const store = useStore();

    const form: UnwrapRef<PAY010> = reactive({
      conveni: "",
    });

    form.conveni = store.state.renewal?.rnw01p?.tfReconv ?? "";

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);
    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({});
    // フィールドエラー設定初期化
    const f$ = useVuelidate(PAY010FormValidateRule, form, {
      $autoDirty: true,
      $externalResults,
    });

    // 更新手続き処理呼び出し
    const submit = async () => {
      g$.splice(0, g$.length);
      f$.value.$touch();
      if (f$.value.$invalid) {
        scrollToError();
        return;
      }

      try {
        if (store.state.renewal === undefined) {
          router.push({ name: "Renewal" });
          return;
        } else {
          store.commit(MutationTypes.SET_CONVENI, form.conveni);
          const res = await postRenewalChange(store.state.renewal);

          store.commit(MutationTypes.SET_CONVENI_RESPONSE, res.data);
        }

        router.push({ name: "RenewalSubmited" });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 400) {
          setErrorMessage(g$, $externalResults, err.response?.data as ErrorResponse);
          scrollToError();
        }
        if (axios.isAxiosError(err) && err.response?.status === 409) {
          g$.push("すでにデータが変更されています。一覧画面から再度実行してください");
        }
      }
    };

    return {
      form,
      g$,
      f$,
      submit,
      constants,
    };
  },
});
